import { render, staticRenderFns } from "./NavView.vue?vue&type=template&id=cf8a2760&scoped=true"
import script from "./NavView.vue?vue&type=script&lang=js"
export * from "./NavView.vue?vue&type=script&lang=js"
import style0 from "./NavView.vue?vue&type=style&index=0&id=cf8a2760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8a2760",
  null
  
)

export default component.exports